/** * @fileoverview 記事情報を操作するVueコンポーネント * @author y.okita * *
@todo * 1. ソースコードの整理: 変数や関数の配置、命名規則を見直す。 * 2.
URLの監視:
トークンやIDなどのURLパラメータの変化を監視し、必要に応じてデータの取得や更新を行う処理を追加する。
* 3. URLのプッシュ:
操作に応じて適切なURLをブラウザの履歴にプッシュする処理を追加する。 */

<template>
  <i
    v-if="articles.id"
    class="bi bi-arrow-left-circle back-button"
    @click="goBack"
  ></i>
  <div class="content_parent registration d-flex flex-column">
    <div v-if="articles.articleId" class="content_line">
      <div class="item_parent">
        <div class="content_title">
          <div class="texttitle">ID</div>
        </div>
        <div class="content_item">
          <p class="article-id" v-text="articles.articleId"></p>
        </div>
      </div>
    </div>
    <div v-if="false" class="content_line">
      <div class="item_parent">
        <div class="content_title">
          <div class="texttitle">種別</div>
        </div>
        <div class="content_item">
          <select class="form-select" v-model="articles.kind" disabled>
            <option value="1">フリー</option>
          </select>
        </div>
      </div>
    </div>
    <div class="content_line">
      <div class="item_parent">
        <div class="content_title">
          <div class="texttitle">カテゴリ</div>
        </div>
        <div class="content_item">
          <select class="form-select" v-model="articles.category">
            <option
              v-for="category in categories"
              :value="category.value"
              :key="category.text"
            >
              {{ category.text }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="content_line">
      <div class="item_parent item_parent_long">
        <div class="content_title">
          <div class="texttitle">記事タイトル</div>
        </div>
        <div class="content_item flex-column">
          <div class="article_title d-flex flex-row mt-2">
            <input
              class="form-control"
              type="text"
              maxlength="100"
              v-model="articles.title"
            />
          </div>
          <p v-if="isTitleInvalid" class="error-message error-message-date">
            記事タイトルは必須です
          </p>
        </div>
      </div>
    </div>

    <div class="content_line">
      <div class="item_parent item_parent_long">
        <div class="content_title">
          <div class="texttitle">シリーズ</div>
        </div>
        <div class="content_item">
          <input
            class="form-control"
            type="text"
            maxlength="40"
            v-model="articles.series"
          />
        </div>
      </div>
    </div>
    <div class="content_line">
      <div class="item_parent item_parent_long">
        <div class="content_title">
          <div class="texttitle">著者</div>
        </div>
        <div class="content_item">
          <input
            class="form-control"
            type="text"
            maxlength="20"
            v-model="articles.writer"
          />
        </div>
      </div>
    </div>
    <div class="content_line">
      <div class="item_parent item_parent_long">
        <div class="content_title">
          <div class="texttitle">タグ</div>
        </div>
        <div class="content_item">
          <input
            class="form-control"
            type="text"
            maxlength="50"
            v-model="articles.tag"
          />
        </div>
      </div>
    </div>
    <div class="content_line d-flex flex-row">
      <div class="content_title">
        <div class="texttitle_wrap">レース</div>
      </div>
      <div class="d-flex flex-column mt-1">
        <div class="d-flex flex-row flex-wrap">
          <div class="item_parent">
            <div class="row_texttitle">レース日</div>
            <div class="content_item">
              <VueCtkDateTimePicker
                button-now-translation="現在時刻"
                class=""
                :button-clear="false"
                v-model="articles.raceDate"
                format="YYYY-MM-DD"
                formatted="YYYY年MM月DD日"
                :no-header="true"
                label="日付を選択"
                no-label
                only-date
                auto-close
              />
            </div>
          </div>
          <div class="item_parent">
            <div class="row_texttitle">レース場</div>
            <div class="content_item">
              <select
                class="form-select"
                v-model="articles.boatracePlace"
                @change="setNullIfEmpty('boatracePlace')"
                name="boatrace_course"
              >
                <option value=""></option>
                <option
                  v-for="place in places"
                  :value="place.value"
                  :key="place.text"
                >
                  {{ place.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="item_parent">
            <div class="row_texttitle">レース番号</div>

            <div class="content_item">
              <select
                class="form-select"
                v-model="articles.raceNo"
                @change="setNullIfZero('raceNo')"
                name="race_no"
              >
                <option value="0"></option>
                <option
                  v-for="raceNo in raceNos"
                  :value="raceNo.value"
                  :key="raceNo.text"
                >
                  {{ raceNo.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="item_parent">
            <div class="row_texttitle">レース前/後</div>
            <div class="content_item">
              <select
                class="form-select"
                v-model="articles.toFro"
                @change="setNullIfEmpty('toFro')"
                name="to_fro"
              >
                <option value=""></option>
                <option
                  v-for="toFro in toFros"
                  :value="toFro.value"
                  :key="toFro.text"
                >
                  {{ toFro.text }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <p class="error-message" v-if="raceErrorMessage">
          {{ raceErrorMessage }}
        </p>
      </div>
    </div>

    <div class="content_line d-flex flex-row">
      <div class="item_parent">
        <div class="content_title">
          <div class="texttitle">コメント種別</div>
        </div>
        <div class="content_item">
          <select class="form-select" v-model="articles.commentKind">
            <option value=""></option>
            <option
              v-for="commentKind in commentKinds"
              :value="commentKind.value"
              :key="commentKind.text"
            >
              {{ commentKind.text }}
            </option>
          </select>
        </div>
      </div>
      <div class="item_parent">
        <div class="content_item">
          <div class="form-check">
            <label for="notNews" class="font-bold form-check-label"
              >ニュースに掲載しない</label
            >
            <input
              class="form-check-input"
              v-model="checkboxNotNews"
              type="checkbox"
              id="notNews"
            />
          </div>
        </div>
      </div>
      <div class="item_parent ms-5">
        <div class="form-check">
          <label for="pr" class="font-bold form-check-label">PR</label>
          <input
            id="pr"
            class="form-check-input"
            type="checkbox"
            v-model="checkboxPr"
          />
        </div>
      </div>
    </div>
    <div class="article_block_parent d-flex flex-column">
      <CustomQuillEditor
        ref="imageDeleteRef"
        v-for="(article, index) in articles.article"
        :key="index"
        :btnClick="btnClick"
        :index="index"
        :isBodyInvalid="isBodyInvalid"
        :quills="quills"
      />
      <div class="content_line d-flex flex-row">
        <button class="article_block submit_button" @click="blockAdd">
          記事ブロックの追加
        </button>
        <button class="article_block submit_button" @click="blockClear">
          記事ブロックの削除
        </button>
      </div>
    </div>
    <div class="content_line d-flex flex-row">
      <div class="item_parent">
        <div class="form-check form-pr">
          <label for="pagging" class="font-bold form-check-label"
            >ページングする</label
          >
          <input
            id="pagging"
            class="form-check-input"
            type="checkbox"
            v-model="checkboxPagging"
          />
        </div>
      </div>
      <div class="item_parent">
        <div class="texttitle">NEWアイコン表示</div>
        <div class="content_item">
          <select class="form-select" v-model="articles.newIcon">
            <option value=""></option>
            <option
              v-for="newIcon in newIcons"
              :value="newIcon.value"
              :key="newIcon.text"
            >
              {{ newIcon.text }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="content_line d-flex frex-row align-items-center">
      <div class="item_parent">
        <div class="content_title">
          <div class="texttitle">公開日時</div>
        </div>
        <div class="content_item flex-column">
          <div class="d-flex flex-row mt-2">
            <VueCtkDateTimePicker
              button-now-translation="現在時刻"
              class=""
              :button-clear="false"
              v-model="articles.fromDate"
              format="YYYY-MM-DDTHH:mm"
              formatted="YYYY年MM月DD日 HH:mm"
              :no-header="true"
              label="日付を選択"
              no-label
              no-clear-button
              auto-close
            />
            <span class="span-nami">～</span>
            <VueCtkDateTimePicker
              button-now-translation="現在時刻"
              class=""
              :button-clear="false"
              v-model="articles.toDate"
              format="YYYY-MM-DDTHH:mm"
              formatted="YYYY年MM月DD日 HH:mm"
              :no-header="true"
              label="日付を選択"
              no-label
              no-clear-button
              auto-close
            />
          </div>
          <p
            v-if="isFromToDateInvalid"
            class="error-message error-message-date"
          >
            掲載開始時刻と掲載終了時刻が不正です
          </p>
        </div>
      </div>
      <div class="item_parent">
        <div class="content_item"></div>
      </div>
    </div>
    <div class="content_line d-flex frex-row">
      <div class="item_parent">
        <div class="content_item mx-2">
          <div class="form-check">
            <label for="immediate" class="font-bold form-check-label"
              >即時公開</label
            >
            <input
              class="form-check-input"
              :disabled="!hasPermission(roleStore.role, 'PUBLISH_INSTANTLY')"
              id="immediate"
              type="checkbox"
              v-model="checkboxImmediatelyOpen"
            />
          </div>
        </div>
      </div>
      <div class="item_parent">
        <div class="row_texttitle">承認</div>
        <div class="content_item">
          <select
            class="form-select"
            :disabled="!hasPermission(roleStore.role, 'PUBLISH_INSTANTLY')"
            v-model="articles.approval"
          >
            <option value="2">未承認</option>
            <option value="1">承認</option>
            <option value="3">却下</option>
          </select>
        </div>
      </div>
    </div>
    <div class="send_button">
      <button
        :disabled="!hasPermission(roleStore.role, 'ARTICLE_REGIST')"
        class="send_button submit_button"
        @click="send"
      >
        登録
      </button>
      <!---->
      <button
        v-if="articles.articleId"
        class="send_button submit_button"
        @click="previewArticle(articles.articleId, articles.category)"
      >
        プレビュー
      </button>
      <!-- <button v-if="articles.articleId" :disabled="!hasPermission(roleStore.role, 'ARTICLE_REGIST')"
                class="send_button submit_button" @click="nextArtickes">次の新規記事を作成</button>-->
    </div>
  </div>
</template>

<script setup>
import axios from "axios";
import { useStore } from "@/store/authStore";
import { useCodeStore } from "@/store/codeStore";
import { useApiStore } from "@/store/apiStore";
import { useArticleStore } from "@/store/articleStore";
import { useRouter, useRoute } from "vue-router";
import { ref, computed, watch, onMounted, watchEffect } from "vue";
import CustomQuillEditor from "../components/CustomQuill.vue";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import useRole from "@/components/role";
import { useRoleStore } from "@/store/roleStore";
const roleStore = useRoleStore();
const { hasPermission } = useRole();
// ストアの使用
const store = useStore();
const codeStore = useCodeStore();
const apiStore = useApiStore();
const articleStore = useArticleStore();

const router = useRouter();
const route = useRoute();

/**
 * ユーザーを前のページに遷移させる関数
 */
const goBack = () => {
  router.go(-1);
};

//ヘッダ‐の作成
const tokenHeaders = store.getTokenHeaders;
const articleId = ref({ id: "" });
let quills = [];
const apiUrl = apiStore.getArticlePath;
let articles = articleStore.getArticles;
// 日付のフォーマット
let formattedFromDate = ref(codeStore.formatDateTime(articles.fromDate));
let formattedToDate = ref(codeStore.formatDateTime(articles.toDate));

/**
 * 掲載開始・終了日時を監視し、日付のフォーマットを更新
 */
watch(
  () => articles.fromDate,
  (newValue) => {
    formattedFromDate.value = codeStore.formatDateTime(newValue);
  }
);
watch(
  () => articles.toDate,
  (newValue) => {
    formattedToDate.value = codeStore.formatDateTime(newValue);
  }
);

/**
 * 各チェックボックスの状態をリアクティブに管理
 */
const checkboxPr = computed({
  get: () => articles.pr === 1,
  set: (value) => {
    articles.pr = value ? 1 : 0;
  },
});
const checkboxPagging = computed({
  get: () => articles.pagging === 1,
  set: (value) => {
    articles.pagging = value ? 1 : 0;
  },
});
const checkboxNotNews = computed({
  get: () => articles.notNews === 1,
  set: (value) => {
    articles.notNews = value ? 1 : 0;
  },
});

const checkboxImmediatelyOpen = computed({
  get: () => articles.immediatelyOpen === 1,
  set: (value) => {
    articles.immediatelyOpen = value ? 1 : 0;
    if (value) {
      const now = new Date();
      articles.fromDate = now;
      articles.approval = 1; // 承認に設定
    }
  },
});

/**
 * プロパティが"0"ならnullに設定する
 * @param {string} prop - プロパティ名
 */
const setNullIfZero = (prop) => {
  if (articles[prop] === "0") {
    articles[prop] = null;
  }
};

/**
 * プロパティが空文字列ならnullに設定する
 * @param {string} prop - プロパティ名
 */
const setNullIfEmpty = (prop) => {
  if (articles[prop] === "") {
    articles[prop] = null;
  }
};

/**
 * 記事から空の記事を削除する関数
 * @param {array} article - 記事の配列
 * @return {array} 空の記事が削除された記事の配列
 */
const removeEmptyArticle = (article) => {
  return article.filter((article) => article.blockNo !== 0);
};

// コードストアからのプルダウンデータの取得
const places = codeStore.places;
const commentKinds = codeStore.commentKind;
const toFros = codeStore.toFro;
const categories = codeStore.category.filter((item) => item.text !== "動画");
const newIcons = codeStore.newIcon;

const raceNos = codeStore.raceNo;

const btnClick = ref(1);

// 記事ブロックを追加
const blockAdd = () => {
  // ブロックの上限数は10
  if (btnClick.value <= 10) {
    btnClick.value++;
  } else {
    alert("記事ブロックはこれ以上追加できません");
  }
};
const imageDeleteRef = ref(null);
// 記事ブロックを削除
const blockClear = () => {
  if (!window.confirm("削除しますか？")) {
    return;
  }
  // 最低でも1つのブロックは残す
  if (btnClick.value > 1) {
    const articleToReset = articles.article[btnClick.value - 1];
    Object.assign(articleToReset, {
      header: "",
      body1: "",
      articlehtml: "",
      image: null,
      explain: "",
      layout: "",
      credit: "",
    });
    imageDeleteRef.value[btnClick.value - 1].fileDelete();
    articles.article[btnClick.value - 1].image = null;
    quills[btnClick.value - 1].setContents([]);
    btnClick.value--;
  } else {
    alert("最後の1つは削除できません");
  }
};

// カテゴリに基づいてURL部分を取得
const getCategoryUrlPart = (value) => {
  switch (value) {
    case "01":
    case "02":
      return "news";
    case "03":
      return "column";
    case "04":
      return "movie";
    default:
      return "";
  }
};

/**
 * プレビューボタンの関数
 * @param {string} id - 記事のID
 * @param {string} categoryValue - カテゴリの値
 */
const previewArticle = async (id, categoryValue) => {
  try {
    const apiUrlPre = apiStore.getIssuekeyPath;
    const response = await axios.get(apiUrlPre, tokenHeaders);
    if (response.status == 200) {
      const urlPart = getCategoryUrlPart(categoryValue);
      const previeUrl = `${process.env.VUE_APP_PREVIEW_SERVER}/article/${urlPart}/${id}?key=${response.data.key}`;
      window.open(previeUrl, "_blank");
    }
  } catch (error) {
    alert("キー取得に失敗しました。", error);
  }
};

const raceErrorMessage = ref();

// 許可されたパターンをデータとして定義
const allowedPatterns = [
  { raceDate: false, boatracePlace: false, raceNo: false, toFro: false },
  { raceDate: true, boatracePlace: false, raceNo: false, toFro: false },
  { raceDate: true, boatracePlace: false, raceNo: false, toFro: true },
  { raceDate: true, boatracePlace: true, raceNo: false, toFro: true },
  { raceDate: true, boatracePlace: true, raceNo: false, toFro: false },
  { raceDate: true, boatracePlace: true, raceNo: true, toFro: false },
  { raceDate: true, boatracePlace: true, raceNo: true, toFro: true },
];

/**
 * レース情報の入力チェック関数。
 * 入力されたレース情報が許可されたパターンに合致するかを検証し、
 * 不一致の場合は適切なエラーメッセージを設定する。
 */
const validate = () => {
  // articlesが未定義の場合、関数を終了
  if (!articles) {
    return;
  }
  // エラーメッセージの初期化
  raceErrorMessage.value = "";

  // 入力値のパターンを定義
  const inputPattern = {
    raceDate: !!articles.raceDate,
    boatracePlace: !!articles.boatracePlace,
    raceNo: articles.raceNo != null && articles.raceNo !== 0, // nullまたは0の場合はfalse、それ以外はtrue
    toFro: !!articles.toFro && articles.toFro !== " ", // 空文字列やnullの場合はfalse、空白文字" "の場合もfalse
  };

  // 最小不一致パターンとその不一致数を初期化
  let minimumMismatchPattern = null;
  let minimumMismatchCount = Infinity;

  // 許可されたパターンごとに検証
  allowedPatterns.forEach((pattern) => {
    let mismatchCount = 0;
    let isSubPattern = true;

    // 各キーに対して入力パターンと許可されたパターンを比較
    Object.keys(inputPattern).forEach((key) => {
      if (inputPattern[key] && !pattern[key]) {
        isSubPattern = false;
      }
      if (inputPattern[key] !== pattern[key]) {
        mismatchCount++;
      }
    });

    // サブパターンかつ最小不一致数の場合、パターンを更新
    if (isSubPattern && mismatchCount < minimumMismatchCount) {
      minimumMismatchCount = mismatchCount;
      minimumMismatchPattern = pattern;
    }
  });

  if (minimumMismatchPattern) {
    const errorMessages = [];
    // 最小不一致パターンに対して、各キーの日本語名を取得し、エラーメッセージを生成
    Object.keys(inputPattern).forEach((key) => {
      if (!inputPattern[key] && minimumMismatchPattern[key]) {
        let jpName = "";
        switch (key) {
          case "raceDate":
            jpName = "レース日";
            break;
          case "boatracePlace":
            jpName = "レース場";
            break;
          case "raceNo":
            jpName = "レース番号";
            break;
          case "toFro":
            jpName = "レース前/後";
            break;
        }
        errorMessages.push(jpName);
      }
    });

    // エラーメッセージがあれば設定
    if (errorMessages.length > 0) {
      raceErrorMessage.value = `${errorMessages.join(
        "、"
      )}が選択されていません。`;
    }
  } else {
    raceErrorMessage.value = "選択された組み合わせは許可されていません。";
  }
};

// 各項目の変更を監視し、変更があった場合に入力チェック
watchEffect(validate);

/**
 * 指定IDの記事を取得する関数
 * @param {string} newId - 新しいID
 */
const get = async (newId) => {
  try {
    // API URLにIDを追加
    const apiUrlId = apiStore.getArticlePathForId(newId);
    // axiosでgetリクエストを送信
    const response = await axios.get(apiUrlId, tokenHeaders);
    // 取得した記事の数で記事ブロックの表示数を調整
    if (response.data.article.length > 1) {
      btnClick.value = response.data.article.length;
    }

    // 取得した記事データをarticleStoreに更新
    articleStore.setArticles(response.data);
    for (let i = 0; i < response.data.article.length; i++) {
      articleStore.updateArticle(i, response.data.article[i]);
    }
    for (let key in articleStore.articles) {
      articles[key] = articleStore.articles[key];
    }
    articles.immediatelyOpen = isNaN(
      parseInt(response.data.immediatelyOpen, 10)
    )
      ? 0
      : parseInt(response.data.immediatelyOpen, 10);
    articles.pagging = isNaN(parseInt(response.data.pagging, 10))
      ? 0
      : parseInt(response.data.pagging, 10);
    articles.pr = isNaN(parseInt(response.data.pr, 10))
      ? 0
      : parseInt(response.data.pr, 10);
    articles.notNews = isNaN(parseInt(response.data.notNews, 10))
      ? 0
      : parseInt(response.data.notNews, 10);
    articles.articleId = response.data.id;
  } catch (error) {
    alert("検索エラー: " + error.message);
  }
};

onMounted(async () => {
  if (!route.params.id) {
    articleId.value = 0;
    articleStore.$reset();
  }
});

watch(
  () => route.params,
  async (newParams) => {
    //URLのidが0以外なら検索
    if (!newParams.id) {
      articleId.value = 0;
      articleStore.$reset();
      if (!sessionStorage.getItem("isReloaded")) {
        sessionStorage.setItem("isReloaded", "true");
        location.reload();
      } else {
        sessionStorage.removeItem("isReloaded");
      }
      return;
    }
    try {
      // 検索を実行
      get(newParams.id);
    } catch (error) {
      console.error(error);
    }
  },
  { immediate: true, deep: true }
); //即時実行と深い監視

let hasSubmitted = ref(false);
let errMessage = ref();
let isFromToDateInvalid = ref(false);
let isBodyInvalid = ref(false);
let isTitleInvalid = computed(() => hasSubmitted.value && !articles.title);

// データ送信処理
const send = async () => {
  hasSubmitted.value = true;
  // Quillエディターの状態をコピー
  let quillsCopy = Object.values(quills);
  quillsCopy = quillsCopy.filter((quill) => quill.getText().trim().length > 0);

  articles.article = JSON.parse(JSON.stringify(articleStore.articles.article));
  // quillエディターの内容が必要な数存在するかチェック
  if (quillsCopy.length != btnClick.value) {
    isBodyInvalid.value = true;
  } else {
    isBodyInvalid.value = false;
  }
  // 掲載開始と終了の日時のバリデーション
  if (formattedToDate.value <= formattedFromDate.value) {
    isFromToDateInvalid.value = true;
  } else {
    isFromToDateInvalid.value = false;
  }

  let messages = [];

  if (isFromToDateInvalid.value) {
    messages.push("掲載開始時刻と掲載終了時刻が不正です");
  }

  if (isBodyInvalid.value) {
    messages.push("本文が入力されていない記事ブロックがあります");
  }

  if (isTitleInvalid.value) {
    messages.push("記事タイトルが入力されていません");
  }

  if (raceErrorMessage.value) {
    messages.push(raceErrorMessage.value);
  }

  errMessage.value = messages.join("\n");

  // 入力エラーがある場合は処理を止める
  if (
    isBodyInvalid.value ||
    isFromToDateInvalid.value ||
    isTitleInvalid.value ||
    raceErrorMessage.value
  ) {
    alert(errMessage.value);
    return;
  }

  // blockNoをセット
  for (let i = 0; i < btnClick.value; i++) {
    articles.article[i].blockNo = i + 1;
  }
  //articlesをディープコピー
  let sendArticlesData = JSON.parse(JSON.stringify(articles)); //Object.assign({},articles);
  //blockNoが0(空)のarticleオブジェクトを削除
  let filteredArticle = removeEmptyArticle(sendArticlesData.article);

  // 各記事のbodyとhtmlをquillの状態からセット
  for (let i = 0; i < quillsCopy.length; i++) {
    filteredArticle[i].body1 = JSON.stringify(quillsCopy[i].getContents());
    filteredArticle[i].articlehtml = quillsCopy[i].root.innerHTML;
  }

  // 各種日時をフォーマットに合わせてセット
  sendArticlesData.article = filteredArticle;
  sendArticlesData.fromDate = formattedFromDate.value;
  sendArticlesData.toDate = formattedToDate.value;
  sendArticlesData.recordDate = codeStore.formatDateTime(new Date());
  console.log(sendArticlesData.article);
  let response = null;
  let putOrPost = 0; //put:1、post:2
  // 既に記事が存在する場合はput, それ以外はpostリクエストを送る
  if (articles.articleId) {
    const apiUrlId = apiStore.getArticlePathForId(articles.articleId);
    response = await axios
      .put(apiUrlId, sendArticlesData, tokenHeaders)
      .catch(function (error) {
        console.log(error.toJSON());
      });
    putOrPost += 1;
  } else {
    response = await axios
      .post(apiUrl, sendArticlesData, tokenHeaders)
      .catch(function (error) {
        console.log(error.toJSON());
      });
    putOrPost += 2;
  }

  // レスポンスがエラーだった場合はアラートを出す
  if (!response) {
    alert("登録エラー");
    return;
  }

  // レスポンスが成功だった場合、成功メッセージとともに記事IDを表示
  if (response.status === 200) {
    switch (putOrPost) {
      case 1:
        alert(`記事ID:${sendArticlesData.articleId}を更新しました。`);
        break;
      case 2:
        articles.articleId = response.data.id;
        alert(`新規で記事を登録しました。\n 記事IDは${response.data.id}です`);
        break;
    }
  } else {
    console.error("データの取得に失敗しました");
    alert("登録できませんでした。");
  }
};
</script>

<style scoped>
.article-id {
  margin: 0;
  margin-left: 1rem;
  font-weight: bold;
}

.article_container {
  margin: 0.5em;
  border: 1px solid #aaa;
}

.long-input {
  width: 100%;
}

.article_block {
  margin: 0.4em 1em;
  min-width: 45%;
}

.font-bold {
  font-weight: bold;
}

.article_title {
  width: 100%;
}

.back-button {
  font-size: 2rem;
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 1000;
  /* 他の要素よりも上に表示するためのz-index */
  padding: 10px 20px;
  background-color: #333;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
}

.back-button:hover {
  opacity: 0.5;
}
</style>
